import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import OrderPickingIcon from "../../assets/icons/OrderPickingGray.svg";
import Downarrow from "../../assets/icons/downarrow.svg";
import MinusCircleIcon from "../../assets/icons/minus-circle-icon.svg";
import PlusCircleIcon from "../../assets/icons/plus-circle-icon.svg";
import Header from "../../layouts/Header";
import {
  CreateOrderPicking,
  ProductProjectDropdown,
} from "../../redux/actions/action";
import "../../assets/styles/local/OrderPicking.css";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import { CREATE_ORDER_PICKING } from "../../redux/constants/type";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import AddPurchaseOrderDocument from "./AddPurchaseOrderDocument";

const OrderPickingProjectListMobile = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const projectDropRef = useRef(null);
  const productDropRef = useRef(null);
  const location = useLocation();
  const projectId = location.state?.projectId;
  const orderid = location.state?.orderid;
  const projectName = location.state?.projectName;

  const fetchProductDropdownData = useSelector(
    (state) => state.user.fetchProductDropdown,
  );
  const fetchCreateOrderPicking = useSelector(
    (state) => state.user.createOrderPicking,
  );
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  const [typeField, setTypeField] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [query, setQuery] = useState("");
  const [showClientDrop, setShowClientDrop] = useState(false);
  const [showProductDrop, setShowProductDrop] = useState(false);
  const screenSize = useScreenSize();
  const [selectedProductMobile, setsSelectedProductMobile] = useState();
  const [productTableData, setProductTableData] = useState([]);
  const [productBottomTableData, setProductBottomTableData] = useState();
  const [searchItems, setSearchItems] = useState("");
  const [productId, setProductId] = useState("");
  const myAppName = localStorage.getItem("myAppName");
  const isOrderPicking = myAppName === "orderpicking";

  useEffect(() => {
    fetchScreenTranslations("Order Picking").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  useEffect(() => {
    if (orderid) {
      // dispatch(ProductProjectDropdown(projectId));
      dispatch(ProductProjectDropdown(null, orderid));
    }
  }, [dispatch, orderid]);

  useEffect(() => {
    if (fetchProductDropdownData != null) {
      if (fetchProductDropdownData?.status) {
        setProductTableData(fetchProductDropdownData?.data);
      }
    }
  }, [fetchProductDropdownData]);

  useEffect(() => {
    if (fetchCreateOrderPicking != null) {
      if (fetchCreateOrderPicking?.status) {
        dispatch({
          type: CREATE_ORDER_PICKING,
          data: {},
        });
        setShowConfirmationModal(true);
        if (productBottomTableData) {
          setProductBottomTableData((prevData) => ({
            ...prevData,
            newQtyToPick: 0,
          }));
        }

        setProductTableData([]);
        if (orderid) {
          dispatch(ProductProjectDropdown(null, orderid));
        }

        handleGeneralNotification({
          notificationType: "CUSTOM",
          text: `Great Job! The product was picked for the project.`,
        });
      }
    }
  }, [fetchCreateOrderPicking]);

  useEffect(() => {
    if (searchItems) {
      if (fetchProductDropdownData != null) {
        if (fetchProductDropdownData?.status) {
          const dataToSet = productTableData?.filter((name) =>
            name.productPartName.toLowerCase().includes(searchItems),
          );
          setProductTableData(dataToSet);
        }
      }
    } else {
      setProductTableData(fetchProductDropdownData?.data);
    }
  }, [searchItems]);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      projectDropRef.current &&
      !projectDropRef.current.contains(event.target)
    ) {
      setShowClientDrop(false);
    }
    if (
      productDropRef.current &&
      !productDropRef.current.contains(event.target)
    ) {
      setShowProductDrop(false);
    }
  };

  const handleSelectedProduct = (items) => {
    const updatedData = {
      ...items,
      qtyToPick: items.qtyToPick,
      newQtyToPick: items.qtyToPick,
    };
    setProductBottomTableData(updatedData);
    setShowProductDrop(false);
    setProductId(items.productPartid);
  };

  const HandleAddPickingOrder = () => {
    if (
      productBottomTableData?.instock === 0 ||
      productBottomTableData?.newQtyToPick > productBottomTableData?.instock ||
      productBottomTableData?.newQtyToPick >
        productBottomTableData?.qtyToPick ||
      productBottomTableData?.qtyToPick === 0 ||
      productBottomTableData?.newQtyToPick === 0
    ) {
      handleGeneralNotification({
        notificationType: "CUSTOM",
        text: `please adjust qty to pick according to a stock.`,
      });
      return;
    }
    setTypeField("");
    const orderProductQty = [
      {
        orderproductqty: productBottomTableData.newQtyToPick,
      },
    ];
    dispatch(
      CreateOrderPicking("", productId, projectId, orderid, orderProductQty),
    );
  };

  const HandleAddPickingOrderMobile = (item) => {
    setTypeField("");
    const orderProductQty = [
      {
        orderproductqty: item.qtyToPick,
      },
    ];
    dispatch(
      CreateOrderPicking(
        "",
        item.productPartid,
        projectId,
        orderid,
        orderProductQty,
      ),
    );

    if (screenSize === "xs" || isOrderPicking) {
      setShowConfirmationModal(true);
    }
  };

  if (
    (screenSize === "xs" || isOrderPicking) &&
    selectedProductMobile &&
    selectedProductMobile?.productPartid &&
    selectedProductMobile?.productPartid !== ""
  ) {
    return (
      <>
        <Header setQuery={setQuery} />
        <div className="container-fluid">
          <div className=" main-wrapper mb-4">
            <div>
              <div
                style={{
                  display: "flex",
                  // gap: "10px",
                  // justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", gap: "1px" }}>
                  <div
                    onClick={() => {
                      history.push("/stock");
                    }}
                    style={{
                      color: "#7F7E7F",
                      fontWeight: "bolder",
                      fontSize: "1.1rem",
                      marginTop: "10px",
                      marginBottom: "15px",
                    }}
                  >
                    {/* Stock */}
                    {t("Stock")}
                  </div>
                  <img
                    alt=""
                    src={Downarrow}
                    style={{
                      opacity: "60%",
                      marginTop: "18px",
                      marginBottom: "15px",
                      width: "15px",
                      height: "12px",
                      transform: "rotate(90deg)",
                      cursor: "pointer",
                    }}
                  />
                  <div
                    onClick={() => {
                      history.push("/order-picking");
                    }}
                    style={{
                      color: "#7F7E7F",
                      fontWeight: "bolder",
                      fontSize: "1rem",
                      marginTop: "11px",
                      marginBottom: "15px",
                    }}
                  >
                    List
                  </div>
                </div>
                <div
                  style={{ display: "flex", gap: "5px", marginRight: "20px" }}
                >
                  <img
                    alt=""
                    src={OrderPickingIcon}
                    className="ms-1"
                    style={{
                      marginTop: "11px",
                      marginBottom: "15px",
                      width: "15px",
                      height: "24px",
                      transform: "rotate(0deg)",
                      cursor: "pointer",
                    }}
                  />
                  <div
                    className="order-picking-head"
                    style={{
                      color: "#7F7E7F",
                      fontWeight: "bolder",
                      marginTop: "11px",
                      marginBottom: "15px",
                      fontSize: "1rem",
                    }}
                  >
                    {/* Order Picking */}
                    {t("Order Picking")}
                  </div>
                </div>
              </div>

              <div className={`${"order-picking-content-mobile"}`}>
                <div className="row">
                  <div className="p-0 col-xl-8">
                    <div
                      className="list-Of-Field"
                      style={{ position: "relative", paddingBottom: "45px" }}
                    >
                      <div className={"choose-project-dropdown-mobile"}>
                        <div
                          className={
                            "project-drop-view-mobile d-flex justify-content-between"
                          }
                        >
                          <p className="productpartcodeTxt">
                            {/* {selectedProductMobile?.productPartCode} */}
                            <img
                              src={selectedProductMobile?.barCode}
                              alt="Barcode"
                              style={{ width: "100%", height: "100px" }}
                            />
                          </p>
                        </div>
                      </div>
                      <div>
                        <p style={{ marginTop: "30px", textAlign: "center" }}>
                          {selectedProductMobile?.productPartName}
                        </p>
                      </div>

                      <div className={"choose-project-dropdown-mobile"}>
                        <div className={"project-drop-view-mobile-1 "}>
                          <p style={{ paddingTop: "10px" }}>
                            {projectName || ""}
                          </p>
                        </div>
                      </div>
                      <div>
                        <div className="justify-content-around  mb-3">
                          <div
                            className="d-flex mb-3 w-100 align-items-center justify-content-center"
                            style={{ gap: "20px" }}
                          >
                            <div
                              style={{
                                width: "80px",
                                height: "40px",
                                border: "1px solid rgba(0, 0, 0, 0.3)",
                                borderRadius: "5px",
                                position: "relative",
                              }}
                            >
                              <label
                                style={{
                                  position: "absolute",
                                  top: "-10px",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  background: "#fff",
                                  padding: "0 5px",
                                  color: "rgba(0, 0, 0, 0.5)",
                                  fontSize: "10px",
                                }}
                              >
                                {/* Color */}
                                {t("Color")}
                              </label>

                              <div
                                className="order-table-output"
                                style={{
                                  display: "flex",
                                  height: "40px",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {productBottomTableData.color !== null ? (
                                  <span
                                    className="color-circle-order"
                                    style={{
                                      backgroundColor: `${productBottomTableData.color}`,
                                    }}
                                  ></span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>

                            <div
                              style={{
                                width: "80px",
                                height: "40px",
                                border: "1px solid rgba(0, 0, 0, 0.3)",
                                borderRadius: "5px",
                                position: "relative",
                              }}
                            >
                              <label
                                style={{
                                  whiteSpace: "nowrap",
                                  position: "absolute",
                                  top: "-10px",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  background: "#fff",
                                  padding: "0 5px",
                                  color: "rgba(0, 0, 0, 0.5)",
                                  fontSize: "10px",
                                }}
                              >
                                {/* In Stock */}
                                {t("In Stock")}
                              </label>
                              <div
                                className="order-table-output"
                                style={{
                                  display: "flex",
                                  height: "40px",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {productBottomTableData.instock}
                              </div>
                            </div>
                          </div>
                          <div className="gap-3 d-flex justify-content-center align-items-center">
                            <img
                              alt=""
                              src={MinusCircleIcon}
                              className="MinusCircleIcon"
                              onClick={() => {
                                if (productBottomTableData) {
                                  let newValue =
                                    productBottomTableData?.newQtyToPick
                                      ? parseInt(
                                          productBottomTableData?.newQtyToPick,
                                        ) - 1
                                      : parseInt(
                                          productBottomTableData.qtyToPick,
                                        ) - 1;
                                  if (newValue < 0) newValue = 0;
                                  setProductBottomTableData((prevData) => ({
                                    ...prevData,
                                    newQtyToPick: newValue,
                                  }));
                                }
                              }}
                            />
                            <div
                              className="order-table-output"
                              style={{
                                position: "relative",
                                width: "100%",
                              }}
                            >
                              <label
                                style={{
                                  fontSize: "12px",
                                  position: "absolute",
                                  top: "-10px",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  background: "#fff",
                                  padding: "0 5px",
                                  color: "rgba(0, 0, 0, 0.5)",
                                }}
                              >
                                {/* Qty to Pick */}
                                {t("Qty to Pick")}
                              </label>
                              <input
                                style={{
                                  border: "1px solid rgba(0, 0, 0, 0.3)",
                                  borderRadius: "5px",
                                  width: "100%",
                                  height: "40px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  textAlign: "center",
                                }}
                                value={
                                  productBottomTableData?.newQtyToPick ??
                                  productBottomTableData?.qtyToPick ??
                                  0
                                }
                                min={0}
                                type="number"
                                onChange={(e) => {
                                  let newValue = +e.target.value;
                                  setProductBottomTableData((prevData) => ({
                                    ...prevData,
                                    newQtyToPick: newValue,
                                  }));
                                }}
                              />
                            </div>
                            <img
                              alt=""
                              src={PlusCircleIcon}
                              className="PlusCircleIcon"
                              onClick={() => {
                                if (productBottomTableData) {
                                  let newValue =
                                    productBottomTableData?.newQtyToPick
                                      ? parseInt(
                                          productBottomTableData?.newQtyToPick,
                                        ) + 1
                                      : parseInt(
                                          productBottomTableData.qtyToPick,
                                        ) + 1;
                                  if (newValue < 0) newValue = 0;
                                  setProductBottomTableData((prevData) => ({
                                    ...prevData,
                                    newQtyToPick: newValue,
                                  }));
                                }
                              }}
                            />
                          </div>
                          {productBottomTableData?.newQtyToPick >
                          productBottomTableData?.instock ? (
                            <span style={{ color: "red" }}>
                              Qty can't exceed stock
                            </span>
                          ) : productBottomTableData?.newQtyToPick >
                            productBottomTableData?.instock ? (
                            <span style={{ color: "red" }}>
                              You cannot pick item above the qtyToPick
                            </span>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            position: "fixed",
            bottom: "0",
            width: "100%",
            background: "#fafafa",
          }}
        >
          <div style={{ width: "100%", padding: "20px" }}>
            <button
              style={{
                width: "100%",
                backgroundColor: "white",
                border: "1px solid #707070",
                color: "#707070",
                fontWeight: "900",
              }}
              className="worktime-cancel-btn"
              onClick={() => {
                history.push("/order-picking");
              }}
            >
              {/* Cancel */}
              {t("Cancel")}
            </button>

            <button
              // disabled={selectedProject == null}
              style={{ width: "100%", marginTop: "7px" }}
              className="worktime-add-btn frc"
              onClick={HandleAddPickingOrder}
            >
              <p>
                {/* Add */}
                {t("Add")}
              </p>
            </button>
          </div>
        </div>

        {showConfirmationModal && (
          <div className="wt-modal-background-mobile d-none">
            <div className="confirmation-modal-div-mobile">
              <div
                style={{
                  marginRight: "80px",
                  marginLeft: "80px",
                  color: "white",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  height: "60vh",
                }}
              >
                <p>
                  The product was successfully picked and added to the project.
                </p>
                <p style={{ fontWeight: "700" }}>
                  Do you want to keep picking more products for this project.
                </p>
              </div>
              <div
                style={{
                  gap: "10px",
                  width: "100%",
                  position: "fixed",
                  bottom: 30,
                  left: 0,
                  right: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <button
                  type="button"
                  style={{
                    width: "80%",
                    height: "60px",
                    border: "1px solid white",
                    background: "#01246B",
                    fontWeight: "900",
                    color: "white",
                  }}
                  className="btn addParchCancel"
                  onClick={() => {
                    history.push("/stock");
                  }}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn addParchCancel"
                  style={{
                    width: "80%",
                    height: "60px",
                    fontWeight: "900",
                    color: "#01246B",
                  }}
                  onClick={() => {
                    setShowConfirmationModal(false);
                    setsSelectedProductMobile();
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
  const handleClose = () => setModalShow(false);
  const handleCancel = (e) => {
    history.goBack();
  };
  return (
    <>
      <Header
        setQuery={setQuery}
        leftComponent={
          <div className="products-and-parts-header-content">
            <div
              className="products-and-parts-main-title  cursor-pointer"
              onClick={() => {
                history.push("/stock");
              }}
            >
              {/* Stock */}
              {t("Stock")}
            </div>
            <p className="products-and-parts-sub-title">
              {/* Order Picking */}
              {t("Order Picking")}
            </p>
          </div>
        }
      />
      {modalShow && (
        <CancelWarningModal
          show={modalShow}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}
      <RouteLeavingGuard
        when={typeField !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          if (typeField !== "") {
            if (!["/stock"].includes(location.pathname)) {
              return true;
            }
          }
          return false;
        }}
      />
      <div className="container-fluid">
        <div className=" main-wrapper mb-4">
          <div className="OrderPicking-outer">
            {(screenSize === "xs" || isOrderPicking) && (
              <>
                <div
                  style={{
                    display: "flex",
                    // gap: "10px",
                    // justifyContent: "space-between",
                  }}
                >
                  <div style={{ display: "flex", gap: "1px" }}>
                    <div
                      onClick={() => {
                        history.push("/stock");
                      }}
                      style={{
                        color: "#7F7E7F",
                        fontWeight: "bolder",
                        fontSize: "1.1rem",
                        marginTop: "10px",
                        marginBottom: "15px",
                      }}
                    >
                      {/* Stock */}
                      {t("Stock")}
                    </div>
                    <img
                      alt=""
                      src={Downarrow}
                      style={{
                        opacity: "60%",
                        marginTop: "18px",
                        marginBottom: "15px",
                        width: "15px",
                        height: "12px",
                        transform: "rotate(90deg)",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        history.goBack();
                      }}
                    />
                    <div
                      onClick={() => {
                        history.push("/order-picking");
                      }}
                      style={{
                        color: "#7F7E7F",
                        fontWeight: "bolder",
                        fontSize: "1rem",
                        marginTop: "11px",
                        marginBottom: "15px",
                      }}
                    >
                      List
                    </div>
                    <img
                      alt=""
                      src={Downarrow}
                      style={{
                        opacity: "60%",
                        marginTop: "18px",
                        marginBottom: "15px",
                        width: "15px",
                        height: "12px",
                        transform: "rotate(90deg)",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  <div
                    style={{ display: "flex", gap: "5px", marginRight: "10px" }}
                  >
                    <img
                      alt=""
                      src={OrderPickingIcon}
                      style={{
                        marginTop: "12px",
                        marginBottom: "15px",
                        width: "15px",
                        height: "24px",
                        transform: "rotate(0deg)",
                        cursor: "pointer",
                      }}
                    />
                    <div
                      style={{
                        color: "#7F7E7F",
                        fontWeight: "bolder",
                        fontSize: "1rem",
                        marginTop: "11px",
                        marginBottom: "15px",
                      }}
                    >
                      {/* Order Picking */}
                      {t("Order Picking")}
                    </div>
                  </div>
                </div>

                <div className="ps-" style={{ paddingBottom: "0px" }}>
                  <AddPurchaseOrderDocument
                    // poOrderCode={poOrderCode}
                    orderid={orderid}
                    isDisabled={true}
                  />
                </div>
              </>
            )}

            <div className="order-picking-content-mobile">
              <div className="row">
                <div className="p-0 col-xl-8">
                  <div
                    className="list-Of-Field"
                    style={{ position: "relative" }}
                    ref={productDropRef}
                  >
                    <div
                      className="project-lable d-flex justify-content-between align-items-center"
                      style={{ borderBottom: "1px dotted #A5A5A5" }}
                    >
                      <p
                        className="project-lable-heading ms-0"
                        style={{
                          color: "#333333",
                          padding: "10px 0",
                          fontWeight: "bold",
                        }}
                      >
                        Items To Be Picked
                      </p>
                      <p
                        className="project-lable-heading ms-0"
                        style={{
                          color: "#333333",
                          padding: "10px 0",
                          fontWeight: "normal",
                          width: "60%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          textAlign: "end",
                        }}
                      >
                        {projectName}
                      </p>
                    </div>

                    <div>
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          borderBottom: "1px dotted #A5A5A5",
                          padding: "10px 0",
                        }}
                      >
                        <p
                          style={{
                            width: "60%",
                            color: "#323232",
                            marginBottom: "0",
                            fontWeight: "bold",
                          }}
                        >
                          Item
                        </p>
                        <p
                          style={{
                            width: "45%",
                            color: "#323232",
                            marginBottom: "0",
                            fontWeight: "bold",
                          }}
                        >
                          Qty
                        </p>
                        <p
                          style={{
                            width: "20%",
                            color: "#323232",
                            marginBottom: "0",
                            fontWeight: "bold",
                          }}
                        >
                          Confirm
                        </p>
                      </div>
                      {productTableData?.map((item) => {
                        return (
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              padding: "5px 0",
                              borderBottom: "1px dotted #A5A5A5",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ width: "45%" }}>
                              <p
                                style={{
                                  width: "85%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  display: "block",
                                  marginBottom: "0",
                                }}
                              >
                                {item?.productPartCode}
                              </p>
                              <p
                                style={{
                                  width: "85%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  display: "block",
                                  marginBottom: "0",
                                  color: "#323232",
                                }}
                              >
                                {item?.productPartName}
                              </p>
                            </div>
                            <div style={{ width: "45%" }}>
                              <span
                                style={{
                                  paddingBottom: "5px",
                                  color: "#323232",
                                }}
                              >
                                {item?.qtyToPick ?? "-"}
                              </span>
                              <p
                                className="mb-0 mt-1"
                                style={{
                                  fontSize: "12px",
                                  borderTop: "1px dotted #A5A5A5",
                                  width: "max-content",
                                  color:
                                    item?.qtyToPick > item?.instock
                                      ? "red"
                                      : "",
                                }}
                              >
                                {/* In Stock */}
                                {t("In Stock")}
                              </p>
                              <span
                                style={{
                                  color:
                                    item?.qtyToPick > item?.instock
                                      ? "red"
                                      : "",
                                }}
                              >
                                {item?.instock}
                              </span>
                            </div>
                            {item?.ispicked === 1 ||
                            item?.qtyToPick <= item?.instock ? (
                              <input
                                class={`form-check-input pointer ${item?.ispicked === 1 && "pointerNone"}`}
                                type="checkbox"
                                id="ascOrderPicking"
                                // checked={item?.qtyToPick === 0 ? true : false}
                                checked={item?.ispicked === 1 ? true : false}
                                onClick={() => {
                                  if (item?.ispicked === 1) return;
                                  HandleAddPickingOrderMobile(item);
                                }}
                              />
                            ) : (
                              <img
                                onClick={() => {
                                  handleSelectedProduct(item);
                                  setsSelectedProductMobile(item);
                                  setTypeField("asc");
                                }}
                                alt=""
                                src={Downarrow}
                                style={{
                                  opacity: "20%",
                                  width: "18px",
                                  height: "12px",
                                  transform: "rotate(-90deg)",
                                  cursor: "pointer",
                                }}
                              />
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* buttons below */}
            <div
              style={{
                display: "none",
                position: "fixed",
                bottom: "0",
                width: "80%",
                background: "#fafafa",
              }}
            >
              <div style={{ width: "100%", padding: "20px" }}>
                <button
                  style={{
                    width: "100%",
                    height: "50px",
                    // fontSize: "14px",
                    backgroundColor: "white",
                    border: "1px solid #707070",
                    color: "#707070",
                    fontWeight: "900",
                  }}
                  className="worktime-cancel-btn"
                  onClick={() => {
                    history.push("/order-picking");
                  }}
                >
                  {/* Cancel */}
                  {FetchTranslationList[22]?.translation}
                </button>

                <button
                  // disabled={selectedProject == null}
                  style={{
                    width: "100%",
                    marginTop: "7px",
                    height: "50px",
                    // fontSize: "14px",
                  }}
                  className="worktime-add-btn frc"
                  onClick={HandleAddPickingOrder}
                >
                  <p>
                    {/* Add */}
                    {FetchTranslationList[23]?.translation}
                  </p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderPickingProjectListMobile;
